import React, { useState, useEffect } from "react";
import Header from "../headers/header";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../contexts/theme";
import FormatLineChart from "../../visualizations/FormatLineChart";
import { GetWindowData } from "../../forge/main";
import { GetLast24Hours } from "../global/GetCurrentTime";
import convertToKST from "../global/convertToKST";
import DatePicker from "../global/DatePicker";

const WaterDetection = () => {
  const [data, setData] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  // const tunnel1 = 1217226;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const title_str = "WINDOW";
  const subtitle_str = [
    "창문 상태를 보여주는 화면입니다 (1: true, 0: false). 한 센서부터 정보를 가져옵니다."
  ];

  const DataChange = (lists) => {

    let d = { id: "Tunnel1", color: "hsl(231, 70%, 50%)", data: [] };

    if (!lists || lists.length === 0) return [];

    const parseLastDateToDate = (str) => {
      const [yyyy, MM, dd, time] = str.split(".");
      const [hh, mm, ss] = time.split(":");
      return new Date(`${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}`);
    };

    for(let i=0; i<lists.length; i++){
      const date = parseLastDateToDate(lists[i]["lastDate"]);
      d.data.push({ x: date, y: lists[i]["open"] });
    }

    return [d];
  };

  useEffect(() => {
    const [Tfrom, Tto] = GetLast24Hours();
    const KSTfrom = convertToKST(Tfrom);
    const KSTto = convertToKST(Tto);
    setFrom(KSTfrom);
    setTo(KSTto);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetWindowData();
        const windowData = response.newData;

        const fromDate = new Date(from);
        const toDate = new Date(to);

        const parseLastDateToDate = (str) => {
          const [yyyy, MM, dd, time] = str.split(".");
          const [hh, mm, ss] = time.split(":");
          return new Date(`${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}`);
        };
        
        const filtered = windowData.filter((item) => {
          const itemDate = parseLastDateToDate(item.lastDate);
          return itemDate >= fromDate && itemDate <= toDate;
        });

        const d = DataChange(filtered);
        setData(d);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (from && to) {
      fetchData();
    }
  }, [from, to]);

  return (
    <div>
      <Header title={title_str} subtitle={subtitle_str} />
      <Box>
        <DatePicker from={from} to={to} setFrom={setFrom} setTo={setTo} />
      </Box>
      <Box className="main-box" backgroundColor={colors.primary[400]}>
        <Box className="main-box-detail">
          <Box>
            <Typography variant="h3" fontWeight="600" color={colors.grey[100]}>
              창문 데이터
            </Typography>
          </Box>
        </Box>
        <Box className="main-box-graph">
          {data && (
            <FormatLineChart data={data} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default WaterDetection;